import { FC } from "react";
import { InputText, Span } from "@goodfill/ui-components";
import { RegulatoryField } from "./RegulatoryField";
import { RegulatoryQuestionField } from "./RegulatoryQuestionField";
import { RegulatoryInformation } from "@goodfill/domain-customer-application-types";

interface RegulatoryInformationSectionProps {
  regulatoryInformation: RegulatoryInformation;
}

export const RegulatoryInformationSection: FC<RegulatoryInformationSectionProps> = ({ regulatoryInformation }) => {
  return (
    <div className="page-account-info-regulatory">
      <div className="flex flex-col my-1 md:my-2 mx-4 md:mx-8 px-4 md:px-8 gap-4 md:gap-8">
        <div className="flex flex-col">
          <div className="flex items-center justify-between my-2 md:my-4">
            <Span font="semibold" size="lg">
              Affiliation Relationship
            </Span>
          </div>
          <div className="flex flex-col px-1 md:px-2">
            <RegulatoryField label="Is affiliated">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={regulatoryInformation.affiliation.isAffiliated ? "Yes" : "No"}
                // setValue={setName}
                disabled={true}
              />
            </RegulatoryField>
            <RegulatoryField label="Relationship">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={true}
              />
            </RegulatoryField>
            <RegulatoryField label="Is Duplicate Statement Required">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={true}
              />
            </RegulatoryField>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex items-center justify-between my-2 md:my-4">
            <Span font="semibold" size="lg">
              Affiliated Company
            </Span>
          </div>
          <div className="flex flex-col px-1 md:px-2">
            <RegulatoryField label="Street 1">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={false}
              />
            </RegulatoryField>
            <RegulatoryField label="Street 2">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={false}
              />
            </RegulatoryField>
            <RegulatoryField label="City">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={false}
              />
            </RegulatoryField>
            <RegulatoryField label="State">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={false}
              />
            </RegulatoryField>
            <RegulatoryField label="Country">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={false}
              />
            </RegulatoryField>
            <RegulatoryField label="Zip code">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={false}
              />
            </RegulatoryField>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex items-center justify-between my-2 md:my-4">
            <Span font="semibold" size="lg">
              Regulatory Control
            </Span>
          </div>
          <RegulatoryQuestionField
            answer={regulatoryInformation.employeeOfPubliclyTradedCompany.isEmployeeOfPubliclyTradedCompany}
            companyStockSymbols={regulatoryInformation.employeeOfPubliclyTradedCompany.companyStockSymbols}
          />
          <RegulatoryQuestionField
            answer={regulatoryInformation.controlOfPubliclyTradedCompany.hasControlOfPubliclyTradedCompany}
            companyStockSymbols={regulatoryInformation.controlOfPubliclyTradedCompany.companyStockSymbols}
          />
        </div>
      </div>
    </div>
  );
};
